export type RangeMode = 'week' | 'today' | 'all';

export interface Settings {
  titleFont: string;
  titleSize: number;
  timeFont: string;
  timeSize: number;
  range: RangeMode;
}

export const FONT_CHOICES: { label: string; value: string }[] = [
  { label: 'System (Standard)', value: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif' },
  { label: 'Segoe UI', value: '"Segoe UI", sans-serif' },
  { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
  { label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
  { label: 'Trebuchet MS', value: '"Trebuchet MS", sans-serif' },
  { label: 'Georgia', value: 'Georgia, serif' },
  { label: 'Times New Roman', value: '"Times New Roman", serif' },
  { label: 'Courier New', value: '"Courier New", monospace' },
];

export const DEFAULT_SETTINGS: Settings = {
  titleFont: FONT_CHOICES[0].value,
  titleSize: 14,
  timeFont: FONT_CHOICES[0].value,
  timeSize: 12,
  range: 'week',
};

const KEY = 'fk-settings';

function clampSize(v: unknown, fallback: number): number {
  const n = Number(v);
  return Number.isFinite(n) ? Math.min(32, Math.max(8, Math.round(n))) : fallback;
}

export function loadSettings(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const p = JSON.parse(raw) as Partial<Settings>;
    const range: RangeMode = p.range === 'today' || p.range === 'all' ? p.range : 'week';
    return {
      titleFont: typeof p.titleFont === 'string' ? p.titleFont : DEFAULT_SETTINGS.titleFont,
      titleSize: clampSize(p.titleSize, DEFAULT_SETTINGS.titleSize),
      timeFont: typeof p.timeFont === 'string' ? p.timeFont : DEFAULT_SETTINGS.timeFont,
      timeSize: clampSize(p.timeSize, DEFAULT_SETTINGS.timeSize),
      range,
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(s: Settings): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* Speicher nicht verfügbar – Einstellungen gelten nur für diese Sitzung */
  }
  applySettings(s);
}

export function applySettings(s: Settings): void {
  const st = document.documentElement.style;
  st.setProperty('--title-font', s.titleFont);
  st.setProperty('--title-size', `${s.titleSize}px`);
  st.setProperty('--time-font', s.timeFont);
  st.setProperty('--time-size', `${s.timeSize}px`);
}
